import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    background: {
      default: "#111111", // Hintergrundfarbe
    },
  },
  breakpoints: {
    values: {
      // extra-small
      xs: 0,
      // small
      sm: 600,
      // medium
      md: 1080,
      // large
      lg: 1200,
      // extra-large
      xl: 1536,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#2196f3", // Blaue Hintergrundfarbe
          color: "white", // Weiße Textfarbe
          borderRadius: "7px",
          border: "1px solid #2196f3",
          "&:hover": {
            backgroundColor: "#1565c0", // Dunklere blaue Hintergrundfarbe bei Hover
          },
          "@media (max-width: 600px)": {
            fontSize: "14px", // Mobile font size
          },
          textTransform: "none", // Kein Großbuchstabe
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          backgroundColor: "#111111", // Hintergrundfarbe
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          justifyContent: "center", // Zentriert die Grid Elemente
          display: "flex",
          paddingLeft: "16px",
          paddingRight: "16px",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          height: "1px",
          backgroundColor: "#2196f3",
          //width: "300%",
          //marginLeft: "-50vw",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "white", // Weiße Textfarbe
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: "#333333", //"rgba(0,0,255,0.4)", // Hintergrundfarbe
        },
      },
    },
  },
});

export default theme;

export const tabsMenuSize = 160;
